// Vendors
import React, { useState } from 'react';
import { Panel, ClearRefinements } from 'react-instantsearch-dom';
import classnames from 'classnames';
import AnimateHeight from 'react-animate-height';

// Components
import { RefinementList } from '..';

const Facet = ({ id, title, attribute_name }) => {
  const [refinementShow, setRefinementShow] = useState(true);
  const panelClassNames = classnames('product-sidebar__title', {
    [`toggle__switch--on`]: refinementShow
  });

  return (
    <Panel
      id={`facets-${id}`}
      className={`product-sidebar__facet product-sidebar__facet-${id}`}
    >
      <div className="product-sidebar__facet-title">
        <h6
          className={panelClassNames}
          onClick={() => setRefinementShow(!refinementShow)}
        >
          {title}
        </h6>
        <ClearRefinements
          transformItems={(items) =>
            items.filter(
              ({ attribute }) => attribute == `facets.${attribute_name}`
            )
          }
          translations={{
            reset: 'Clear'
          }}
        />
      </div>
      <AnimateHeight
        duration={300}
        height={refinementShow ? 'auto' : 0}
        easing={'ease-in-out'}
      >
        <div className="form__field">
          <RefinementList
            attribute={`facets.${attribute_name}`}
            showMore={true}
            showMoreLimit={30}
            operator="or"
            transformItems={(items) =>
              items.sort((a, b) => {
                const labelA = a.label.toUpperCase();
                const labelB = b.label.toUpperCase();
                return labelA < labelB ? -1 : labelA > labelB ? 1 : 0;
              })
            }
          />
        </div>
      </AnimateHeight>
    </Panel>
  );
};

export default Facet;
